/**
 * TimeSlot Component
 * Renders a single hour row in the calendar grid with time label.
 * Migrated to Tailwind CSS.
 */

import { formatHour, HOUR_HEIGHT } from '@/lib/calendarUtils';

interface TimeSlotProps {
  /** Hour in 24-hour format (0-23) */
  hour: number;
}

/**
 * Hour slot row with time label and bottom divider line.
 * Height matches HOUR_HEIGHT constant for consistent grid layout.
 * Clockwise-style: time label positioned at the top-right, subtle dotted border.
 */
export function TimeSlot({ hour }: TimeSlotProps) {
  return (
    <div
      className="relative border-b border-dotted border-gray-200"
      style={{ height: HOUR_HEIGHT }}
    >
      {/* Time label positioned at the top-right, sitting on the grid line */}
      <span className="absolute -top-2 right-2 text-[11px] text-gray-400 font-normal bg-white px-1">
        {formatHour(hour)}
      </span>
    </div>
  );
}

export default TimeSlot;
